import {makeGet} from '@yandex-delivery/utils'

import type {OffersCalculateResponseV2} from '../types'

export const offersCalculateGetter = makeGet<OffersCalculateResponseV2>()
export const offerGetter = makeGet<OffersCalculateResponseV2['claims_offers'][number]>()
